import React from "react";

function About() {
  return (
    <div className="min-h-screen m-auto my-10 px-6 max-w-5xl text-white">
      {/* Heading */}
      <h1 className="text-3xl sm:text-5xl font-bold mb-6 text-center">
        About Us
      </h1>

      {/* Intro Section */}
      <p className="text-lg sm:text-xl leading-relaxed text-gray-200 text-center mb-8">
        <span className="font-semibold">BPL - Bargaon Premier League</span> is
        an annual cricket tournament that has been held for the past 5 years.
        Known for thrilling matches, top teams, and exceptional talent, BPL
        brings together cricket enthusiasts from all over.
      </p>

      {/* Tournament Info */}
      <div className="bg-white/10 backdrop-blur-md p-6 rounded-2xl shadow-lg mb-10">
        <h2 className="text-2xl font-semibold mb-4 text-center">
          Our Journey
        </h2>
        <p className="text-base sm:text-lg leading-relaxed text-gray-100">
          The tournament started its <span className="font-semibold">first season </span> 
          with just <span className="font-semibold">4 teams</span>, consisting of both 
          local and overseas players. Since then, BPL has grown into a much-awaited 
          annual sporting event that captures the spirit of cricket and community. 
          Every year, fans gather to witness competitive cricket, teamwork, and 
          extraordinary performances on the field.
        </p>
      </div>

      {/* Key Highlights */}
      <div className="grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-6 text-center">
        <div className="bg-gradient-to-r from-blue-600 to-indigo-500 p-5 rounded-xl shadow-md">
          <h3 className="text-xl font-semibold">Local & Overseas</h3>
          <p className="text-gray-100">Players competing together</p>
        </div>
        <div className="bg-gradient-to-r from-green-600 to-emerald-500 p-5 rounded-xl shadow-md">
          <h3 className="text-xl font-semibold">Community Spirit</h3>
          <p className="text-gray-100">Bringing fans and players closer</p>
        </div>
      </div>

      {/* Closing */}
      <p className="text-center text-gray-300 mt-10 text-base sm:text-lg">
        The Bargaon Premier League isn’t just about cricket — it’s about 
        <span className="font-semibold"> passion, sportsmanship, and unity</span>.  
        We welcome everyone to be a part of this exciting journey every year!
      </p>
    </div>
  );
}

export default About;
